import { makeStyles } from "@material-ui/core";
import { myBlack } from "../../constants/colors";

export const useProgressIndicatorStyles = makeStyles((theme) => ({
  spinner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%'
  },
  placeholder: {
    height: theme.spacing(5)
  },
  progress: {
    width: '100%',
    height: '100vh'
  },
  progressFramed: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed'
  },
  plzWait: {
    position: 'fixed',
    left: 'calc(50% - 50px)',
    top: '50%'
  },
  plzWaitWithDrawer: {
    position: 'fixed',
    left: 'calc(50% - 50px + 160px)',
    top: '50%'
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: myBlack,
    opacity: .15,
    zIndex: 999999
  }
}));
